const M = "/media/menu/";

export const BRAND = {
  name: "Pink Tequila",
  sub: "Mexican Restaurant · Grill & Cantina",
  est: "EST. 2016",
  city: "North Port · Florida",
  tagline: ["Big flavor.", "Bold tradition."],
  phone: "941-564-6644",
  phoneHref: "tel:+19415646644",
  address: "1163 N Toledo Blade Blvd, North Port, FL 34288",
  mapsHref: "https://maps.google.com/?q=1163+N+Toledo+Blade+Blvd+North+Port+FL+34288",
  orderUrl: "https://order.toasttab.com/online/pink-tequila",
  facebook: "https://www.facebook.com/Pinktequilafl/",
  instagram: "https://www.instagram.com/pinktequilafl/",
};

export const HOURS = [
  { day: "Sunday", time: "12:00 PM — 8:00 PM" },
  { day: "Mon — Thu", time: "11:00 AM — 9:00 PM" },
  { day: "Fri — Sat", time: "11:00 AM — 10:00 PM" },
];

export const IMAGES = {
  hero: "/media/stock/b385d02ba778e366.jpg",
  heroFood: "/media/stock/5b7715d92e61b9c4.jpg",
  margaritas: "/media/stock/bcea1627e7680ba3.jpg",
  margaritaBlue: "/media/stock/1bde599012143d8f.jpg",
  tacosTeal: "/media/stock/ccb46a5bb66c1aa8.jpg",
  tacosPlate: "/media/stock/368433b470ab75c7.jpg",
  tiles: "/media/stock/d4c1a84076509138.jpg",
};

// Pink Tequila's own photography (bundled static assets — ship with the build)
export const REAL_PHOTOS = {
  storefront: "/media/restaurant/storefront-night.jpg",
  storefrontPatio: "/media/restaurant/storefront-patio-night.jpg",
  diningLongTable: "/media/restaurant/dining-long-table.jpg",
  diningPapelPicado: "/media/restaurant/dining-papel-picado.jpg",
  diningBooths: "/media/restaurant/dining-booths.jpg",
  boothTable: "/media/restaurant/booth-tiled-table.jpg",
  barMural: "/media/restaurant/bar-mural.jpg",
  barStools: "/media/restaurant/bar-stools.jpg",
  barSaloon: "/media/restaurant/bar-saloon-doors.jpg",
  barNeon: "/media/restaurant/bar-neon.jpg",
  patio: "/media/restaurant/patio.jpg",
  patioPink: "/media/restaurant/patio-pink-chairs.jpg",
  patioTable: "/media/restaurant/patio-tile-table.jpg",
  muralWall: "/media/restaurant/mural-wall.jpg",
  drinks: "/media/photos/drinks.jpg",
  giftCard: "/media/photos/gift-card.jpg",
};

export const DISHES = {
  mariam: "/media/dishes/mariams-burrito.jpg",
  chimichanga: "/media/dishes/chimichanga.jpg",
  choriQueso: "/media/dishes/chori-queso.jpg",
  molcajete: "/media/dishes/molcajete.jpg",
  ceviche: "/media/dishes/ceviche.jpg",
  fajitas: "/media/dishes/fajitas.jpg",
};

export const HERO_MEDIA = {
  video: "/media/hero.mp4",
  poster: "/media/hero-poster.jpg",
};

export const CHAPTERS = [
  { no: "01", label: "The Family", title: "Family owned, endlessly poured.", body: "Pink Tequila was built on a love for bringing people together over great food, awesome drinks, and unforgettable moments. As a family owned and operated restaurant, we pour our passion into every detail — from the flavors in our kitchen to the warmth of our service." },
  { no: "02", label: "The Craft", title: "Fresh ingredients, bold taste.", body: "Traditional recipes and handcrafted drinks served in a warm, vibrant atmosphere. Everything is smashed, squeezed, and grilled to order — the way authentic Mexican cooking was always meant to be." },
  { no: "03", label: "The Fiesta", title: "Where friends become family.", body: "What started as a dream has grown into a place where celebrations come to life and every visit feels like coming home. Come hungry, leave happy — that's the Pink Tequila way." },
];

export const SIGNATURES = [
  { kicker: "Freshly Made", name: "Homemade Guacamole", desc: "Smashed fresh with lime, cilantro, onion and tomato. Served with warm tortilla chips.", img: IMAGES.heroFood, color: "#5B8A5B" },
  { kicker: "Street Style", name: "Mexican Street Tacos", desc: "Soft corn tortillas, your choice of meat, cilantro and onion, lime and homemade hot sauce.", img: IMAGES.tacosTeal, color: "#17A99B" },
  { kicker: "Crafted Daily", name: "Passionate Sunset", desc: "Tequila, passionfruit, fresh squeezed orange juice and a raspberry liqueur floater.", img: REAL_PHOTOS.barStools, color: "#E8603C" },
];

export const MENU = {
  eats: [
    { name: "Mariam's Burrito", price: "$22.99", desc: "Flour tortilla stuffed with grilled chicken, rice and beans, topped with chorizo, pineapple, ham, onions and cilantro, smothered in cheese sauce.", img: M + "menu-image-4.80d947779972a89f765c.png" },
    { name: "Adelitas Quesabirrias", price: "$18.99", desc: "Corn tortillas dipped in birria broth with beef birria and melted cheese, grilled. Rice, grilled onions, jalapeño, cilantro and lime.", img: M + "menu-image-16.fb5fffa3234c774fe54e.png" },
    { name: "Fajita Chimichangas", price: "$25.99", desc: "Deep-fried tortillas stuffed with grilled steak, chicken or mixed, topped with cheese sauce. Rice and beans.", img: M + "menu-image-1.5b9d5d40c6cc804dd42d.png" },
    { name: "Blue Tequila Fajitas", price: "$26.99", desc: "Beef ribs, chorizo, chicken, steak and shrimp with grilled onions, bell peppers and tomatoes.", img: M + "menu-image-1.40141613475203a168c1.png" },
    { name: "Street Mexican Tacos", price: "$18.99", desc: "Three soft corn tortillas, choice of meat, cilantro and onions, rice, beans, lime and homemade hot sauce.", img: M + "menu-image-13.9281fdd3c37a5e8134c5.png" },
    { name: "Homemade Guacamole", price: "$11.99", desc: "Freshly smashed avocado with lime, cilantro, onion, tomato and sea salt. Warm tortilla chips.", img: M + "menu-image-8.e3844db728cf57fde40d.png" },
  ],
  drinks: [
    { name: "Passionate Sunset", price: "$12.00", desc: "Tequila, passionfruit, fresh squeezed orange juice and a raspberry liqueur floater.", img: "/media/stock/904048a96d61ca6e.jpg" },
    { name: "Skinny Margarita", price: "$12.99", desc: "Low calorie and fresh — tequila with fresh squeezed juices.", img: "/media/stock/12bff78438c00955.jpg" },
    { name: "Strawberry Mojito", price: "$10.00", desc: "Classic strawberry mojito with fresh fruit and mint.", img: "/media/stock/3a6199c8def0f73e.jpg" },
    { name: "Michelada", price: "$12.00", desc: "A Mexican Bloody-Mary with your choice of bottled beer.", img: "/media/stock/20f0e60e62e74718.jpg" },
    { name: "La Catrina", price: "$12.00", desc: "Rum, coconut and pineapple tropical drink with toasted coconut.", img: "/media/stock/ffc194c697922be5.jpg" },
    { name: "N/A Flamingo", price: "$5.99", desc: "Pineapple, coconut and watermelon Redbull with muddled mint and orange.", img: "/media/stock/d4603056a7439100.jpg" },
  ],
};

export const TESTIMONIALS = [
  { quote: "Love the atmosphere. Love the people. The food is amazing. Family oriented and a great date night place — a must for fantastic authentic Mexican food!", by: "Google Review", color: "#C9317D" },
  { quote: "We are never disappointed when we eat here. The staff is always accommodating and friendly. Authentic Mexican and the portions are enormous. Gracias.", by: "Google Review", color: "#E8603C" },
  { quote: "Comfortable, friendly staff and atmosphere. The margarita was the best we have had in Florida. Food was great — we will go back for sure.", by: "Google Review", color: "#17A99B" },
];

export const RIBBON = ["Tacos", "Margaritas", "Fajitas", "Birria", "Guacamole", "Quesabirrias", "Micheladas", "Fiesta"];

export const GALLERY = [
  { img: REAL_PHOTOS.diningLongTable, name: "Dining Room" },
  { img: REAL_PHOTOS.barStools, name: "The Bar" },
  { img: DISHES.fajitas, name: "Sizzling Fajitas" },
  { img: REAL_PHOTOS.patioPink, name: "The Patio" },
  { img: REAL_PHOTOS.muralWall, name: "Hand-Painted Murals" },
  { img: REAL_PHOTOS.barSaloon, name: "Cantina Bar" },
  { img: REAL_PHOTOS.storefront, name: "Pink Tequila at Night" },
  { img: DISHES.mariam, name: "Mariam's Burrito" },
  { img: REAL_PHOTOS.diningBooths, name: "Booths & Papel Picado" },
  { img: REAL_PHOTOS.patio, name: "Covered Patio" },
  { img: DISHES.molcajete, name: "Molcajete" },
  { img: DISHES.ceviche, name: "Ceviche" },
];

export const CELEBRATE = [
  { title: "Happy Hour", tag: "Mon – Fri · 3–6 PM", desc: "Half-price house margaritas, tequila and appetizers at the bar — the perfect way to start the fiesta.", img: REAL_PHOTOS.barStools, color: "#E8603C", cta: { label: "See the drinks", href: "/menu" } },
  { title: "Catering", tag: "Any occasion", desc: "Sizzling fajitas, tacos and fresh margaritas brought straight to your event, made to order.", img: M + "menu-image-1.91edb30cecdcc57b401e.png", color: "#C9317D", cta: { label: "Call to plan", href: "tel:+19415646644" } },
  { title: "Private Parties", tag: "Celebrate with us", desc: "Birthdays, anniversaries and family gatherings — big flavors, lively vibes and lasting memories.", img: REAL_PHOTOS.diningLongTable, color: "#7A2C8F", cta: { label: "Book a table", href: "tel:+19415646644" } },
];
